import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';

/**
 * Calculates the loan duration in years based on the provided duration object.
 *
 * @param duration An object containing the loan amount and unit ('days', 'months', or 'years').
 * @returns The loan duration in years.
 */
export const getDurationInYears = (duration: {
    amount: number;
    unit: 'days' | 'months' | 'years';
}): number => {
    return getDurationInMonths(duration) / 12;
};
